import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import Kundli_Main_Banner from '../../kundli/kundli_main_bannner/Kundli_Main_Banner'
import Footer from '../../../common/footer/Footer'
import { Get_Pooja_List, Get_Pooja_List_Auth } from '../../../../api/pooja/Pooja'
import Loader from '../../../../loader/Loader'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { FaArrowCircleRight, FaArrowCircleLeft } from "react-icons/fa";
import { User_Authentication } from '../../../../user_authentication/User_Authentication'
import { toast } from "react-toastify";
import { Helmet } from 'react-helmet'
import parse from 'html-react-parser';






const Book_Pooja_List = () => {
    const navigate = useNavigate()
    const { slug } = useParams()
    const [pooja_list, set_Pooja_List] = useState([]);
    const [pooja_category, set_Pooja_Category] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [selectedDate, setSelectedDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    });

    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12;

    const validPoojaData = Array.isArray(pooja_list) ? pooja_list : [];
    const totalPages = Math.ceil(validPoojaData.length / productsPerPage);

    // Slice data for current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentPoojaList = validPoojaData.slice(startIndex, startIndex + productsPerPage);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };
    // Generate the next 30 days
    const generateDates = () => {
        const dates = [];
        const today = new Date();
        for (let i = 0; i < 30; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);
            dates.push(date);
        }
        return dates;
    };

    const dates = generateDates();

    useEffect(() => {
        const fetchPoojaList = async () => {
            setIsLoading(true);
            try {
                const token = User_Authentication();
                let response;

                if (!token) {
                    response = await Get_Pooja_List(slug);
                } else {
                    response = await Get_Pooja_List_Auth(slug, { Authorization: `Bearer ${token}` });
                }

                const resData = response?.data || response?.response?.data;

                if (resData?.status == 200) {
                    set_Pooja_List(resData?.data?.pooja || []);
                    set_Pooja_Category(resData?.data?.pooja_category || []);
                } else {
                    console.warn("Unexpected response while fetching pooja list:", resData);
                }

            } catch (error) {
                console.error("Error fetching pooja list:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPoojaList();
    }, [slug]);

    const handleDateClick = (date) => {
        const formattedDate = date.toISOString().split('T')[0];
        setSelectedDate(formattedDate);
    };

    // Handle category click
    const handleCategoryClick = (categoryId) => {
        setSelectedCategoryId(categoryId);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <Helmet>
                <title>{pooja_category[0]?.meta_title}</title>
                <meta name="description" content={pooja_category[0]?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}pooja/${pooja_category[0]?.slug}`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}pooja/${pooja_category[0]?.slug}`} />
            </Helmet>
            {/*  */}
            <Header />
            {/*  */}
            {/* <Kundli_Main_Banner /> */}
            {
                isLoading ? (
                    <Loader />
                ) : (
                    <>
                        <section className='gi-banner-section pt-[20px] max-[767px]:py-[30px] wow fadeInUp'>
                            <div
                                className="mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]  px-3">
                                <div class=" w-full inline-block">
                                    <ul class="flex flex-wrap items-center gap-2">
                                        <li class="text-gray-700 capitalize"><div class="text-[12px] font-medium cursor-pointer" onClick={() => {
                                            navigate("/all-pooja-category")
                                        }}>Pooja Categories</div></li>
                                        <li class="text-gray-700 text-[12px]">/</li>
                                        <li class="!text-red-600 !text-[12px] font-medium">{pooja_category[0]?.title}</li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        <div className={`${pooja_category[0]?.banner_image ? "block" : "hidden"}`}>
                            <img src={`${IMG_BASE_URL}${pooja_category[0]?.banner_image}`} alt={pooja_category[0]?.image_alt} className='w-full h-[300px] mt-[20px] object-cover' />
                        </div>
                        <section className="gi-blog-section py-[30px] max-[767px]:py-[30px] wow fadeInUp"
                            style={{ visibility: "visible", animationName: "fadeInUp" }}>
                            <div
                                className="mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]  px-3">
                                <div className="w-full mb-[-24px]">
                                    <div
                                        className="section-title">
                                        <div className="header-search min-w-[300px] relative max-[1399px]:min-w-[500px] max-[1199px]:min-w-[400px] max-[991px]:p-0 max-[767px]:min-w-[350px] max-[480px]:min-w-[300px] max-[320px]:min-w-full">
                                        </div>
                                    </div>

                                    <div className="pb-12">
                                        <div className='title text-center mb-3'>
                                            {pooja_category[0]?.heading && (
                                                <>
                                                    <h1 className='text-2xl text-gray-900 font-bold'>{pooja_category[0]?.heading}</h1>
                                                    <div className='border-b-2 border-gray-900 w-[200px] mx-auto inline-block'></div>
                                                </>
                                            )}
                                        </div>
                                        <section className="sub__title text-gray-900 mb-6">{pooja_category[0]?.description && parse(pooja_category[0]?.description)}</section>
                                        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 inline-block'>

                                            {currentPoojaList?.length > 0 ? currentPoojaList?.map((list_result) => (
                                                <div className='p-4 rounded-xl shadow-custome scale-100 hover:scale-120 hover:shadow-2xl text-center cursor-pointer'
                                                    onClick={() => {
                                                        navigate(`/pooja-detail/${list_result?.slug}`)
                                                    }
                                                    } >
                                                    <div
                                                        className='relative '>
                                                        <img className='rounded-lg size-80 object-cover bg-top w-full' src={`${IMG_BASE_URL}${list_result?.image}`} alt={list_result?.image_alt} />
                                                    </div>
                                                    <a className='relative'><h4 className='text-gray-900 line-clamp-1 font-bold text-lg mt-3'>{list_result?.name}</h4></a>
                                                    <p className='text-gray-700 font-medium text-[13px]'>Packages Starting From</p>
                                                    {list_result?.packages?.amount && (
                                                        <h4 className='text-red-600 font-bold pt-1'>₹ {list_result?.packages?.amount}</h4>
                                                    )}

                                                </div>
                                            )) : (
                                                <div>
                                                    <p>
                                                        Not Found List
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                        {/* Pagination Controls */}
                                        <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                            <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, validPoojaData?.length)} of {pooja_list?.length} items</span>
                                            <ul className="gi-pro-pagination-inner flex">
                                                <li>
                                                    <button onClick={handlePrev} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-red-600 leading-[30px] h-[32px] bg-red-500 flex flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                        Prev
                                                    </button>
                                                </li>

                                                {[...Array(totalPages).keys()].map((page) => (
                                                    <li key={page} className="inline-block float-left mr-[5px]">
                                                        <button
                                                            onClick={() => handlePageChange(page + 1)}
                                                            className={`transition-all duration-[0.3s] m-1 p-2 ease-in-out w-[32px] h-[32px] font-light 
                                                                    text-[#777] leading-[32px] bg-[#eee] flex text-center align-top 
                                                                    text-[16px] justify-center items-center rounded-[5px]
                                                                     ${currentPage === page + 1 ? 'active bg-red-500 text-white' : 'bg-gray-300 text-white'}`}
                                                        >
                                                            {page + 1}
                                                        </button>
                                                    </li>
                                                ))}

                                                <li>
                                                    <button onClick={handleNext} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-red-600 leading-[30px] h-[32px] bg-red-500 flex flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )
            }
            {/*  */}
            <Footer />
        </div>
    )
}

export default Book_Pooja_List